/**
 * Theme entrypoint.
 */

document.addEventListener('DOMContentLoaded', () => {
  const testimonialRoot = document.querySelector('.testimonial-slider');
  const testimonialSwiperEl = document.querySelector('.testimonial-swiper');

  if (testimonialRoot && testimonialSwiperEl && window.Swiper) {
    const currentCounter = testimonialRoot.querySelector('.testimonial-current');
    const totalCounter = testimonialRoot.querySelector('.testimonial-total');
    const formatNumber = (value) => String(value).padStart(2, '0');

    const getSlideNumber = (swiper) => {
      const index = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
      return index + 1;
    };

    const updateCounter = (swiper) => {
      if (currentCounter) {
        currentCounter.textContent = formatNumber(getSlideNumber(swiper));
      }
    };

    const swiper = new window.Swiper(testimonialSwiperEl, {
      slidesPerView: 1,
      loop: true,
      speed: 650,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.testimonial-next',
        prevEl: '.testimonial-prev',
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        init: (swiperInstance) => {
          if (totalCounter) {
            const totalValue = parseInt(totalCounter.dataset.total, 10) || swiperInstance.slides.length;
            totalCounter.textContent = formatNumber(totalValue);
          }
          updateCounter(swiperInstance);
        },
        slideChange: (swiperInstance) => {
          updateCounter(swiperInstance);
        },
      },
    });
  }
});
